import {useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {IState} from '../../../shared/store/reducers';
import {Report} from '../../../shared/models';
import {toggleSelectAllReports} from '../../../shared/store/actions/reportActions';

interface SelectReports {
  allSelected: boolean;
  someSelected: boolean;
  selected: string[];
  selectedDetails: Partial<Report>[];
  onChange: (selected: boolean) => void;
}

export function useSelectReports(): SelectReports {
  const dispatch = useDispatch();
  const reports = useSelector((state: IState) => state.report.reports);

  const noReports = (reports?.length || 0) === 0;
  const allSelected = reports?.every((report: Report) => report.selected) || false;
  const someSelected = reports?.some((report: Report) => report.selected) || false;
  const selectedDetails = reports?.filter((report: Report) => report.selected)
    .map((report: Report) => ({
      id: report.id as number,
      uid: report.uid as string,
      name: report.name as string,
    })) || []; // additional details for selected reports
  const selected = useMemo(() => selectedDetails.map((report: any) => report.uid),
    [selectedDetails.length]);

  const onChange = useCallback((selected: boolean) =>
    dispatch(toggleSelectAllReports(selected)),
    []
  );

  return {
    allSelected: noReports ? false : allSelected,
    someSelected,
    selected,
    selectedDetails,
    onChange,
  }
}
